import { MessageBarType, Stack } from '@fluentui/react';
import * as React from 'react';
import { IEventSchedule } from '../../../../../Models/Event/IEventSchedule';
import { ISchedulesAttendeeList } from '../../../../../Models/Event/ISchedulesAttendeeList';
import { AttendeeListView } from './AttendeeListView';
import { IEventSchedulesApi } from '../../../../../Services/API/EventSchedules/IEventSchedulesApi';
import * as Services from '../../../../../Services/Services';
import { useBoolean } from '@fluentui/react-hooks';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { IUpdateAttendeeOnLesson } from '../../../../../Models/Event/IUpdateAttendeeOnLesson';

interface IAttendeeListProps {
    eventSchedule?: IEventSchedule;
    refresh: () => void;
}


export const AttendeeList: React.FunctionComponent<IAttendeeListProps> = (props) => {

    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>();


    const updateAttendee = async (attendee: IUpdateAttendeeOnLesson) => {

        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const schedulesApi = Services.ServicesProvider.GetService<IEventSchedulesApi>(Services.EventSchedulesApi);
        const result = await schedulesApi.updateAttendeeOnLesson(attendee);
        if (result.isSuccess && result.data) {
            props.refresh();
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }
    return (<Stack>
        <AttendeeListView
            eventId={props.eventSchedule?.eventId ? props.eventSchedule?.eventId:0}
            updateAttendee={updateAttendee}
            items={props.eventSchedule?.attendees ? props.eventSchedule.attendees : []}
            
            isLoading={isLoading}
            selectAttended={function (item: ISchedulesAttendeeList, checked: boolean): void {
            throw new Error('Function not implemented.');
            }}
            selectAttendedAll={function (checked: boolean): void {
            throw new Error('Function not implemented.');
            }}
        />    </Stack>)
}
